import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../Img';
import styles from './GlobalSearchNavigation.scss';

const ChatWithRallyButton = ({ onClick }) => (
    <button
        type="button"
        className={styles.chatWithAceContainer}
        onClick={onClick}
        data-testid="global-search.chat-with-rally-btn"
    >
        <span className={styles.chatWithAceText}>
            <span className={styles.chatWithAcePrimaryText}>
                <span>Chat with</span>
                <span className={styles.chatWithAcePrimaryWord}>Rally</span>
            </span>
            <span className={styles.chatWithAceStar} aria-hidden>
                <Img src="/img/icons/star.svg" alt="" />
            </span>
            <span className={styles.chatWithAceSecondaryText}>about your ratings</span>
        </span>
    </button>
);

ChatWithRallyButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default ChatWithRallyButton;
